import { Component, Input, HostListener, ViewEncapsulation, ViewChild, OnChanges } from '@angular/core';
import { AppComponent } from '../../app.component';
import { UserProfileService } from '../../service/user-profile.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnChanges {
  @Input() isLoggedIn: boolean;
  @ViewChild('opMainMenu') opMainMenu;

  isScrolledDown = false;

  currentLogo = '';
  currentHeaderColor = '';

  constructor(
    public app: AppComponent,
    public userProfileService: UserProfileService,
  ) {
  }

  ngOnChanges() {
    this.currentHeaderColor = '#3a5588';
  }

  @HostListener('window:scroll', ['$event'])
  track(event: any) {
    if (window.pageYOffset > 200) {
      this.isScrolledDown = true;
    } else {
      this.isScrolledDown = false;
    }
  }

  get currentAvatar() {
    const currentUser: firebase.User = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser.photoURL;
  }
}

